/*
 * @Description: 
 * @Version: 2.0
 * @Autor: 一诺(丘汉文)
 * @Date: 2020-04-13 16:43:38
 * @Author: 一诺(丘汉文)
 * @LastEditors: 李方强
 */

export default [
  {
    path: '/juridistion',
    name: 'juridistion',
    meta: {
      title: '企业列表'
    },
    component: () => import(/* webpackChunkName: "example-juridistion" */ '../views/juridistion/juridistion.vue')
  },
  {
    path: '/department',
    name: 'department',
    meta: {
      title: '企业部门管理'
    },
    component: () => import(/* webpackChunkName: "example-juridistion" */ '../views/juridistion/department.vue')
  },
  {
    path: '/rolement',
    name: 'rolement',
    meta: {
      title: '角色管理'
    },
    component: () => import(/* webpackChunkName: "example-juridistion" */ '../views/juridistion/rolement.vue')
  }
]